import script from "./PhoneDead.vue?vue&type=script&setup=true&lang=js"
export * from "./PhoneDead.vue?vue&type=script&setup=true&lang=js"

import "./PhoneDead.vue?vue&type=style&index=0&id=7b39a474&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b39a474"]])

export default __exports__